var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthTabSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#4884E8",
    strokeWidth: 2,
    fill: "#4884E8",
    cx: 20,
    cy: 20,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0FF",
    d: "m20.366 8-.16.547v15.87l.16.16 7.367-4.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.366 8 13 20.223l7.366 4.354v-7.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0FF",
    d: "m20.366 25.972-.09.11v5.653l.09.265 7.371-10.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.366 32v-6.028L13 21.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4D8F9",
    d: "m20.366 24.577 7.367-4.354-7.367-3.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0FF",
    d: "m13 20.223 7.366 4.354v-7.703z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthTabSelected);
export default __webpack_public_path__ + "static/media/ethTabSelected.fe8cb31b.svg";
export { ForwardRef as ReactComponent };